import * as React from 'react';
import { translate } from 'react-i18next';
import ChevronDown from 'wix-ui-icons-common/ChevronDown';
import { PopoverMenu, TextButton, ListItemAction, Divider, } from 'wix-style-react';
import { EditContactEvent, } from '../../../constants/events';
var AddNewField = function (_a) {
    var t = _a.t, onCreateCustomField = _a.onCreateCustomField, handleAddField = _a.handleAddField, log = _a.log, _b = _a.newFields, newFields = _b === void 0 ? [] : _b;
    var visibleNewFields = newFields.filter(function (f) { return f.isShown; });
    var onAddNewFieldPopoverClick = function (toggle) {
        toggle();
        log(EditContactEvent.OPEN_ADD_FIELD_DROPDOWN);
    };
    return (React.createElement(PopoverMenu, { placement: "top", zIndex: 6000, dataHook: "new-field-select-menu", triggerElement: function (_a) {
            var toggle = _a.toggle;
            return (React.createElement(TextButton, { dataHook: "new-field-select", size: "small", suffixIcon: React.createElement(ChevronDown, null), onClick: function () { return onAddNewFieldPopoverClick(toggle); } }, t('editContact.addNewField')));
        } },
        visibleNewFields.map(function (field, index) { return (React.createElement(PopoverMenu.MenuItem, { key: index, text: t("editContact.addNewField." + field.name), dataHook: "addNewField-" + field.name, onClick: function () { return handleAddField(field); } })); }),
        React.createElement(Divider, null),
        React.createElement(ListItemAction, { dataHook: "create-new-custom-field", onClick: onCreateCustomField, title: t('editContact.createNewCustomField'), ellipsis: true })));
};
export default translate()(AddNewField);
//# sourceMappingURL=AddNewField.js.map